export const SET_GROUP = 'SET_GROUP';
export const SET_PRICESINFO = 'SET_PRICESINFO';
export const SET_PRICESINFO_SUCCESS = 'SET_PRICESINFO_SUCCESS';
export const SET_GROUPDETAIL_SYNC = 'SET_GROUPDETAIL_SYNC';
// export const SET_GROUPDETAIL = 'SET_GROUPDETAIL';
// export const SET_GROUPDETAIL_SUCCESS = 'SET_GROUPDETAIL_SUCCESS';
export const SET_STATIONINFO = 'SET_STATIONINFO';
export const SET_STATIONINFO_SUCCESS = 'SET_STATIONINFO_SUCCESS';
export const SET_FLIGHTINFO = 'SET_FLIGHTINFO';
export const SET_FLIGHTINFO_SUCCESS = 'SET_FLIGHTINFO_SUCCESS';
export const SET_CURRENTTOURID = 'SET_CURRENTTOURID';
